module.exports = __webpack_public_path__ + "distribution/img/ico_bg1.bb5da1e2.svg";